export enum RespondentValidationStages {
  validatingToken,
  authenticating,
  tokenError,
}
